import { CgMenuBoxed } from 'react-icons/cg';
import styled from 'styled-components';
import { outlineGray, primaryColor } from '../../config/colors';
import Button from '../Button';

export const Container = styled.div`
  display: flex;
  height: 37px;
  border: 1px solid ${primaryColor};
`;

export const Option = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${({ isSelected }) => isSelected && `background-color: ${primaryColor}; color: white;`}
  transition: opacity .2s ease-out;
  &:hover {
    opacity: 0.7;
  }
`;
